
// @ts-nocheck
import locale__app_apps_jobs_locale_hr_json from "../../jobs/locale/hr.json";
import locale__app_apps_employers_locale_hr_json from "../../employers/locale/hr.json";
import locale__app_apps_articles_locale_hr_json from "../../articles/locale/hr.json";
import locale__app_apps_mojposaohr_locale_hr_json from "../../mojposaohr/locale/hr.json";
import locale__app_apps_jobs_locale_en_json from "../../jobs/locale/en.json";
import locale__app_apps_generic_locale_en_json from "../../generic/locale/en.json";
import locale__app_apps_employers_locale_en_json from "../../employers/locale/en.json";
import locale__app_apps_articles_locale_en_json from "../../articles/locale/en.json";
import locale__app_apps_mojposaohr_locale_en_override_json from "../../mojposaohr/locale/en-override.json";
import locale__app_apps_jobs_locale_sl_json from "../../jobs/locale/sl.json";
import locale__app_apps_employers_locale_sl_json from "../../employers/locale/sl.json";
import locale__app_apps_articles_locale_sl_json from "../../articles/locale/sl.json";
import locale__app_apps_jobs_locale_bs_json from "../../jobs/locale/bs.json";
import locale__app_apps_employers_locale_bs_json from "../../employers/locale/bs.json";
import locale__app_apps_articles_locale_bs_json from "../../articles/locale/bs.json";
import locale__app_apps_jobs_locale_mk_json from "../../jobs/locale/mk.json";
import locale__app_apps_employers_locale_mk_json from "../../employers/locale/mk.json";
import locale__app_apps_articles_locale_mk_json from "../../articles/locale/mk.json";


export const localeCodes =  [
  "hr",
  "en",
  "sl",
  "bs",
  "mk"
]

export const localeLoaders = {
  "hr": [{ key: "../../jobs/locale/hr.json", load: () => Promise.resolve(locale__app_apps_jobs_locale_hr_json), cache: true },
{ key: "../../employers/locale/hr.json", load: () => Promise.resolve(locale__app_apps_employers_locale_hr_json), cache: true },
{ key: "../../articles/locale/hr.json", load: () => Promise.resolve(locale__app_apps_articles_locale_hr_json), cache: true },
{ key: "../../mojposaohr/locale/hr.json", load: () => Promise.resolve(locale__app_apps_mojposaohr_locale_hr_json), cache: true }],
  "en": [{ key: "../../jobs/locale/en.json", load: () => Promise.resolve(locale__app_apps_jobs_locale_en_json), cache: true },
{ key: "../../generic/locale/en.json", load: () => Promise.resolve(locale__app_apps_generic_locale_en_json), cache: true },
{ key: "../../employers/locale/en.json", load: () => Promise.resolve(locale__app_apps_employers_locale_en_json), cache: true },
{ key: "../../articles/locale/en.json", load: () => Promise.resolve(locale__app_apps_articles_locale_en_json), cache: true },
{ key: "../../mojposaohr/locale/en-override.json", load: () => Promise.resolve(locale__app_apps_mojposaohr_locale_en_override_json), cache: true }],
  "sl": [{ key: "../../jobs/locale/sl.json", load: () => Promise.resolve(locale__app_apps_jobs_locale_sl_json), cache: true },
{ key: "../../employers/locale/sl.json", load: () => Promise.resolve(locale__app_apps_employers_locale_sl_json), cache: true },
{ key: "../../articles/locale/sl.json", load: () => Promise.resolve(locale__app_apps_articles_locale_sl_json), cache: true }],
  "bs": [{ key: "../../jobs/locale/bs.json", load: () => Promise.resolve(locale__app_apps_jobs_locale_bs_json), cache: true },
{ key: "../../employers/locale/bs.json", load: () => Promise.resolve(locale__app_apps_employers_locale_bs_json), cache: true },
{ key: "../../articles/locale/bs.json", load: () => Promise.resolve(locale__app_apps_articles_locale_bs_json), cache: true }],
  "mk": [{ key: "../../jobs/locale/mk.json", load: () => Promise.resolve(locale__app_apps_jobs_locale_mk_json), cache: true },
{ key: "../../employers/locale/mk.json", load: () => Promise.resolve(locale__app_apps_employers_locale_mk_json), cache: true },
{ key: "../../articles/locale/mk.json", load: () => Promise.resolve(locale__app_apps_articles_locale_mk_json), cache: true }]
}

export const vueI18nConfigs = [
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "i18n_config_bffaebcb" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "hr",
      "iso": "hr-HR",
      "name": "Hrvatski",
      "files": [
        "../jobs/locale/hr.json",
        "../employers/locale/hr.json",
        "../articles/locale/hr.json",
        "../mojposaohr/locale/hr.json"
      ]
    },
    {
      "code": "en",
      "iso": "en-US",
      "name": "English",
      "files": [
        "../jobs/locale/en.json",
        "../generic/locale/en.json",
        "../employers/locale/en.json",
        "../articles/locale/en.json",
        "../mojposaohr/locale/en-override.json"
      ]
    },
    {
      "code": "sl",
      "iso": "sl-SI",
      "name": "Slovenščina",
      "files": [
        "../jobs/locale/sl.json",
        "../employers/locale/sl.json",
        "../articles/locale/sl.json"
      ]
    },
    {
      "code": "bs",
      "iso": "bs-BA",
      "name": "Bosanski",
      "files": [
        "../jobs/locale/bs.json",
        "../employers/locale/bs.json",
        "../articles/locale/bs.json"
      ]
    },
    {
      "code": "mk",
      "iso": "mk-MK",
      "name": "македонски",
      "files": [
        "../jobs/locale/mk.json",
        "../employers/locale/mk.json",
        "../articles/locale/mk.json"
      ]
    }
  ],
  "defaultLocale": "hr",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": false,
  "langDir": "./locale",
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "config",
  "pages": {
    "job/[jobId]": {
      "hr": "/posao/[jobId]",
      "en": "/job/[jobId]",
      "bs": "/posao/[jobId]",
      "mk": "/rabota/[jobId]"
    },
    "job/[jobId]/[slug]/apply": {
      "hr": "/posao/[jobId]/[slug]/prijava",
      "en": "/job/[jobId]/[slug]/apply",
      "bs": "/posao/[jobId]/[slug]/prijava",
      "mk": "/rabota/[jobId]/[slug]/aplikacija"
    },
    "job/[jobId]/[slug]/apply-external-form": {
      "hr": "/posao/[jobId]/[slug]/apply-external-form",
      "en": "/job/[jobId]/[slug]/apply-external-form",
      "bs": "/posao/[jobId]/[slug]/apply-external-form",
      "mk": "/rabota/[jobId]/[slug]/apply-external-form"
    },
    "job/[jobId]/[slug]/apply-external-countdown": {
      "hr": "/posao/[jobId]/[slug]/apply-external-countdown",
      "en": "/job/[jobId]/[slug]/apply-external-countdown",
      "bs": "/posao/[jobId]/[slug]/apply-external-countdown",
      "mk": "/rabota/[jobId]/[slug]/apply-external-countdown"
    },
    "job/[jobId]/[slug]/details": {
      "hr": "/posao/[jobId]/[slug]",
      "en": "/job/[jobId]/[slug]",
      "bs": "/posao/[jobId]/[slug]",
      "mk": "/rabota/[jobId]/[slug]"
    },
    "info/pravila-privatnosti": {
      "hr": "/info/pravila-privatnosti",
      "en": "/info/privacy-policy",
      "bs": "/info/pravila-privatnosti",
      "mk": "/info/политиката-за-приватност"
    },
    "search/index": {
      "en": "/job-search",
      "hr": "/pretraga-poslova"
    },
    "calculator/salary": {
      "en": "/calculator/salary",
      "hr": "/kalkulator/izracun-place"
    },
    "calculator/author": {
      "en": "/calculator/royalty-contract",
      "hr": "/kalkulator/autorski-ugovor"
    },
    "calculator/service": {
      "en": "/calculator/service-contract",
      "hr": "/kalkulator/ugovor-o-djelu"
    },
    "auth/login": {
      "en": "/login",
      "hr": "/prijava"
    },
    "auth/logout": {
      "en": "/logout",
      "hr": "/odjava"
    },
    "my-profile": {
      "en": "/my-profile",
      "hr": "/moj-profil"
    },
    "my/settings": {
      "en": "/my-profile/settings",
      "hr": "/moj-profil/postavke"
    },
    "my/applications": {
      "en": "/my-profile/applications",
      "hr": "/moj-profil/prijave"
    },
    "my/favorite-jobs": {
      "en": "/my-profile/saved-jobs",
      "hr": "/moj-profil/spremljeni-poslovi"
    },
    "my/documents": {
      "en": "/my-profile/documents",
      "hr": "/moj-profil/dokumenti"
    },
    "my/notifications": {
      "en": "/my-profile/notifications",
      "hr": "/moj-profil/obavijesti"
    },
    "faq/index": {
      "en": "/faq",
      "hr": "/cesta-pitanja"
    },
    "faq/[category]": {
      "en": "/faq/[category]",
      "hr": "/cesta-pitanja/[category]"
    },
    "jobs/index": {
      "hr": "/poslovi",
      "sl": "/poslovi",
      "bs": "/poslovi",
      "mk": "/rabotni-mesta",
      "en": "/jobs"
    },
    "jobs/[slug]": {
      "hr": "/poslovi/[slug]",
      "sl": "/poslovi/[slug]",
      "bs": "/poslovi/[slug]",
      "mk": "/rabotni-mesta/[slug]",
      "en": "/jobs/[slug]"
    },
    "advices/index": {
      "hr": "/savjeti",
      "en": "/advices",
      "bs": "/savjeti",
      "mk": "/soveti"
    },
    "advices/search": {
      "hr": "/savjeti/pretrazivanje",
      "en": "/advices/search",
      "bs": "/savjeti/pretrazivanje",
      "mk": "/soveti/search"
    },
    "advices/[adviceId]": {
      "hr": "/savjet/[adviceId]",
      "en": "/advice/[adviceId]",
      "bs": "/savjet/[adviceId]",
      "mk": "/sovet/[adviceId]"
    },
    "advices/[adviceId]/[slug]": {
      "hr": "/savjet/[adviceId]/[slug]",
      "en": "/advice/[adviceId]/[slug]",
      "bs": "/savjet/[adviceId]/[slug]",
      "mk": "/sovet/[adviceId]/[slug]"
    },
    "employers/index": {
      "hr": "/poslodavci",
      "bs": "/poslodavci",
      "sl": "/poslodavci",
      "mk": "/rabotodavaci",
      "en": "/employers"
    },
    "employers/[employerId]": {
      "hr": "/poslodavac/[employerId]",
      "bs": "/poslodavac/[employerId]",
      "sl": "/poslodavac/[employerId]",
      "mk": "/rabotodavac/[employerId]",
      "en": "/employer/[employerId]"
    },
    "employers/[employerId]/[...slug]": {
      "hr": "/poslodavac/[employerId]/[...slug]",
      "bs": "/poslodavac/[employerId]/[...slug]",
      "sl": "/poslodavac/[employerId]/[...slug]",
      "mk": "/rabotodavac/[employerId]/[...slug]",
      "en": "/employer/[employerId]/[...slug]"
    }
  },
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "hr",
    "iso": "hr-HR",
    "name": "Hrvatski",
    "files": [
      {
        "path": "../jobs/locale/hr.json"
      },
      {
        "path": "../employers/locale/hr.json"
      },
      {
        "path": "../articles/locale/hr.json"
      },
      {
        "path": "../mojposaohr/locale/hr.json"
      }
    ]
  },
  {
    "code": "en",
    "iso": "en-US",
    "name": "English",
    "files": [
      {
        "path": "../jobs/locale/en.json"
      },
      {
        "path": "../generic/locale/en.json"
      },
      {
        "path": "../employers/locale/en.json"
      },
      {
        "path": "../articles/locale/en.json"
      },
      {
        "path": "../mojposaohr/locale/en-override.json"
      }
    ]
  },
  {
    "code": "sl",
    "iso": "sl-SI",
    "name": "Slovenščina",
    "files": [
      {
        "path": "../jobs/locale/sl.json"
      },
      {
        "path": "../employers/locale/sl.json"
      },
      {
        "path": "../articles/locale/sl.json"
      }
    ]
  },
  {
    "code": "bs",
    "iso": "bs-BA",
    "name": "Bosanski",
    "files": [
      {
        "path": "../jobs/locale/bs.json"
      },
      {
        "path": "../employers/locale/bs.json"
      },
      {
        "path": "../articles/locale/bs.json"
      }
    ]
  },
  {
    "code": "mk",
    "iso": "mk-MK",
    "name": "македонски",
    "files": [
      {
        "path": "../jobs/locale/mk.json"
      },
      {
        "path": "../employers/locale/mk.json"
      },
      {
        "path": "../articles/locale/mk.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
